import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3be34d7f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hotspot-details-item" }
const _hoisted_2 = { class: "action" }
const _hoisted_3 = { class: "label" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "description" }

import { PropType, computed } from 'vue';
import { useI18n } from 'vue-i18n'
import { useGameState } from '@/services/composition'
import { Hotspot } from '@/services/stores/hotspots'


export default /*#__PURE__*/_defineComponent({
  props: {
  hotspot: {
    type: Object as PropType<Hotspot>,
    required: true
  }
},
  setup(__props) {

const props = __props

const { t } = useI18n()
const state = useGameState()



const hasDoneRight = computed(() => {
  return props.hotspot.points >= 0
})

const icon = computed(() => {
  if (hasDoneRight.value) {
    return 'checkmark'
  } else {
    return 'crossmark'
  }
})

const iconClass = computed(() => {
  if (hasDoneRight.value) {
    return 'icon--success'
  } else {
    return 'icon--fail'
  }
})

const actionLabel = computed(() => {
  if (hasDoneRight.value) {
    return t('end.map.hotspot.action_right')
  } else {
    return t('end.map.hotspot.action_wrong')
  }
})


return (_ctx: any,_cache: any) => {
  const _component_ui_icon = _resolveComponent("ui-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", {
        class: _normalizeClass(['icon', _unref(iconClass)])
      }, [
        _createVNode(_component_ui_icon, { name: _unref(icon) }, null, 8, ["name"])
      ], 2),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(actionLabel)), 1)
    ]),
    _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)(`hotspots.${__props.hotspot.name}.label`)), 1),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", null, _toDisplayString(_unref(t)(`hotspots.${__props.hotspot.name}.description`)), 1)
    ])
  ]))
}
}

})